module.exports = __webpack_public_path__ + "img/arrow-next-grey-icon.svg";